import { styled, useTheme, Typography, Collapse } from '@mui/material';

import RouteAccordion from './Route';
import { useIsMinified } from '../../hooks';

// Groups sit flush for now, alongside the hidden headers below.
const Wrapper = styled('div')({
    paddingTop: 0,
});

const StyledTypography = styled(Typography)(
    ({ theme: { palette, spacing } }) => ({
        color: palette.text.success,
        textTransform: 'uppercase',
        paddingLeft: spacing(1.5),
        marginBottom: 0,
    })
);

const StyledCollase = styled(Collapse)(({ theme }) => ({
    marginTop: theme.spacing(2),
}));

// Group headers are hidden for now. The groups themselves still decide which
// routes belong together and in what order — this only suppresses the label.
const SHOW_GROUP_NAMES = false;

export default ({ groupName, routes }) => {
    const { transitions } = useTheme();
    const isMinified = useIsMinified();

    return (
        <Wrapper>
            {SHOW_GROUP_NAMES && groupName && (
                <StyledCollase
                    in={!isMinified}
                    timeout={transitions.duration.complex}
                >
                    <StyledTypography variant='caption'>
                        {groupName}
                    </StyledTypography>
                </StyledCollase>
            )}
            <Collapse
                in={!!routes.length}
                timeout={transitions.duration.complex * 2}
            >
                {routes.map((route) => (
                    <RouteAccordion {...route} key={route.route} />
                ))}
            </Collapse>
        </Wrapper>
    );
};
